/**
 * Music ducking (audio-direction §4.6): −8 dB while comms are on air, −4 dB for 400 ms after a big impact.
 * When both apply, the deeper one wins (they do not stack). Pure; the engine turns the level into automation.
 */
import type { EngineConfig } from './sfxSchema'

export interface DuckState {
  /** Comms transmissions on air (a count: overlapping lines keep the duck until the last one ends). */
  comms: number
  /** Context time the impact duck ends. */
  impactUntil: number
}

export function createDuckState(): DuckState {
  return { comms: 0, impactUntil: -1 }
}

/** The music duck in dB (≤ 0) at `now`. */
export function duckDb(state: DuckState, now: number, cfg: EngineConfig['ducking']): number {
  const comms = state.comms > 0 ? cfg.commsDb : 0
  const impact = now < state.impactUntil ? cfg.impactDb : 0
  return Math.min(comms, impact, 0)
}

/** Starts (or extends) the impact duck at `now`. */
export function triggerImpactDuck(state: DuckState, now: number, cfg: EngineConfig['ducking']): void {
  state.impactUntil = Math.max(state.impactUntil, now + cfg.impactSeconds)
}
